module.exports = __webpack_public_path__ + "static/media/abouttitleen.1abc62d2.png";